import { Firestore, Firebase } from "../lib/firebase";

export const getLastImageID = async () =>
    Firestore.collection("config")
        .where(Firebase.firestore.FieldPath.documentId(), "==", "swipe_game_config")
        .get()
        .then((results) => {
            const ids = [];
            for (const doc of results.docs) {
                const id = doc.data();
                ids.push(id);
            }
            return ids[0].last_id;
        })
        .catch((error) => {
            throw new Error(error);
        });

export const setLastImageID = async (id) => {
    const codeCollection = Firestore.collection("config").doc(
        "swipe_game_config"
    );

    try {
        codeCollection.update({ last_id: id });
    } catch (error) {
        throw error;
    }
};

export const configThemeSwipeGame = (theme) => {
    const codeCollection = Firestore.collection("config").doc(
        "swipe_game_config"
    );
    const date = Date.now();
    try {
        codeCollection.update({ theme, createdAt: date });
    } catch (error) {
        throw error;
    }
};

export const setDeck = async (payload, lastID) => {
    try {
        for (const product of payload) {
            await Firestore.collection("images").add(product);
        }
        setLastImageID(lastID);
    } catch (error) {
        throw error;
    }
};

export async function getImageById(imageId) {
    const res = await Firestore.collection("images")
        .where('id', "==", imageId)
        .get();

    const images = res.docs.map((image) => image.data());
    return images[0];
}

export async function getImageByDocId(docId) {
    const snapshot = await Firestore.collection("on-boarding-swipe-game")
        .doc(docId)
        .get();

    return snapshot.data();
}
